import React from "react";
import classes from "./NavigationTitle.module.css";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";

const NavigationTitle = ({ title, navigateToHome }) => {
  const navigate = useNavigate();
  const handleNavigate = (route) => {
    if (navigateToHome) {
      navigate("/");
    } else {
      navigate(route);
    }
  };
  return (
    <div className={classes.navigation_container}>
      <div className={classes.back_icon} onClick={() => handleNavigate(-1)}>
        <KeyboardBackspaceIcon sx={{ color: "white", fontSize: "2rem" }} />
      </div>
      <div className={classes.text_container}>
        <h2>{title}</h2>
      </div>
    </div>
  );
};

export default NavigationTitle;
